import { render, staticRenderFns } from "./heat-map.vue?vue&type=template&id=33b0a0f6&scoped=true"
import script from "./heat-map.vue?vue&type=script&lang=js"
export * from "./heat-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b0a0f6",
  null
  
)

export default component.exports